module.exports = __webpack_public_path__ + "media/images/products/template/01/03-3f6bc09cecc432c8a2952df6aeda4c7e.jpg";